import React from 'react';
import { NavLink } from 'react-router-dom';
import { Server } from '../../server/server';
import { getPortraitImage } from '../util/user';
import { BsBoxArrowDown, BsExclamationCircleFill, BsList } from 'react-icons/bs';
import { AppConfig } from '../AppConfig';
import { getIcon } from '../util/icons';
import './HeaderBar.css';
import { setDeviceBadgeCount } from '../util/notifications';

interface HeaderBarProps {
  onLogin: Function
  onLogout: Function
}

interface HeaderBarState {
  openSiteMenu: boolean;
  openUserMenu: boolean;
  navigate: string;
  activity: boolean;
  notifications: boolean;
  chats: boolean;
  offline: boolean;
  friends: boolean;
}

class HeaderBar extends React.Component<HeaderBarProps, HeaderBarState> {
  protected updateTimer:any;
  protected lastIcon: string;
  protected lastPortrait: string;
  protected lastLogo: string;

  constructor(props: HeaderBarProps) {
    super(props);
    this.state = {
      openSiteMenu: false,
      openUserMenu: false,
      navigate: '',
      activity: false,
      chats: false,
      friends: false,
      notifications: false,
      offline: true
    };

    this.updateTimer = null;
    this.lastIcon = '';
    this.lastPortrait = '';
    this.lastLogo = '';

    this.onChatDatesUpdated = this.onChatDatesUpdated.bind(this);
    this.onChatStarted = this.onChatStarted.bind(this);
  }

  componentDidMount() {
    this.updateOnline();
    this.updateActivity();
    this.updateNotifications();
    this.updateChats();
    this.updateTitle();

    this.updateTimer = setInterval(()=>{
      this.updatePortrait();
      this.updateIcon();
      this.updateLogo();
      this.updateOnline();
      this.updateActivity();
      this.updateNotifications();
      this.updateChats();
      this.updateTitle();
    }, 250);

    Server.monitor.addEventListener('chat-dates-updated', this.onChatDatesUpdated);
    Server.monitor.addEventListener('chat-started', this.onChatStarted);
  }

  componentWillUnmount() {
    clearInterval(this.updateTimer);
    Server.monitor.removeEventListener('chat-dates-updated', this.onChatDatesUpdated);
    Server.monitor.removeEventListener('chat-started', this.onChatStarted);
  }

  onChatDatesUpdated(event:any) {
    this.updateChats();
  }

  onChatStarted(event:any) {
    this.updateChats();
  }

  updateOnline() {
    let offline = !Server.network.isConnected();
    if(this.state.offline != offline)
      this.setState({offline});
  }

  updateActivity() {
    if(Server.isLoggingIn() || !AppConfig.community)
      return;

    let activity = Server.monitor.isNewActivity();
    if(this.state.activity != activity) 
      this.setState({activity});
  }

  updateNotifications() {
    if(Server.isLoggingIn() || !AppConfig.community)
      return;

    let notifications = Server.monitor.isNewNotifications();
    if(this.state.notifications != notifications) 
      this.setState({notifications});
  }

  updateChats() {
    if(Server.isLoggingIn() || !AppConfig.community)
      return;

    let parts = window.location.pathname.split('/');

    let currentChat = null;

    if(Server.network.isConnected()) {
      if(parts.length == 3 && parts[1] == 'chat') {
        let slug = parts[2];
        let chatUser = Server.public.getProfileFromSlug(slug);
        if(chatUser) {
          let chats = Server.user.getChats();
          let chat = chats.find((c:any) => c.user == chatUser.id);
          if(chat)
            currentChat = chat.id;
        }
      }
      else if(parts.length == 4 && parts[1] == 'chat' && parts[2] == 'group') {
        let id = parts[3];
        let chats = Server.user.getChats();
        let chat = chats.find((c:any) => c.id == id);
        if(chat)
          currentChat = chat.id;
      }
    }

    let chats = Server.monitor.isNewChat(currentChat);
    if(this.state.chats != chats) 
      this.setState({chats});
  }

  updateTitle() {
    let total = 0;
    if(this.state.activity) total++;
    if(this.state.notifications) total++;
    if(this.state.chats) total++;

    let title = AppConfig.title;
    let n = title.indexOf(') ');
    if(n != -1)
      title = title.substring(n+2);
    if(total > 0) 
      title = `(${total}) ` + title;

    if(title != document.title)
      document.title = title;

    setDeviceBadgeCount(total);
  }

  updateIcon() {
    if(this.lastIcon != AppConfig.icon) {
      this.lastIcon = AppConfig.icon;
      this.forceUpdate();
    }
  }

  updateLogo() {
    if(this.lastLogo != AppConfig.logo) {
      this.lastLogo = AppConfig.logo;
      this.forceUpdate();
    }
  }

  updatePortrait() {
    if(!Server.account.isLoggedIn() || Server.synchronizing)
      return;

    if(Server.user.getPortrait() != this.lastPortrait) {
      this.lastPortrait = Server.user.getPortrait();
      this.forceUpdate();
    }
  }

  onLogoClick(e:any) {
    let hamburger = document.getElementById('hamburger') as HTMLDivElement;
    let display = window.getComputedStyle(hamburger, null).display;

    if(display != 'none') {
      this.setState({openSiteMenu: !this.state.openSiteMenu});
      e.preventDefault();
      e.stopPropagation();
    }
  }

  onLogout() {
    this.setState({openUserMenu: false});
    this.props.onLogout();
  }

  renderSiteMenu() {
    if(!this.state.openSiteMenu)
      return null;

    let buttons = [];
    let menu = AppConfig.menu.site;
    for(let i = 0; i < menu.length; i++) {
      if(menu[i].guest != undefined && menu[i].guest == Server.account.isLoggedIn())
        continue;

      if(menu[i].role != undefined && menu[i].role != Server.user.getRole())
        continue;

      let icon = React.createElement(getIcon(menu[i].icon));

      let notify = menu[i].notify && this.state[menu[i].notify];
      if(notify)
        icon = <div style={{color: 'var(--notification-background-color)'}}><BsExclamationCircleFill size="1.0em" /></div>

      buttons.push(
        <NavLink key={i} to={menu[i].path} onClick={()=>this.setState({openSiteMenu: false})}>
          <div className="site-page-row" style={{justifyContent: 'space-between', marginRight: '5px'}}>
            <div className="site-page-row">
              <div className="site-page-dropdown-menu-icon">{icon}</div>
              <div>{menu[i].name}</div>
            </div>
          </div>
        </NavLink>
      )  
    }

    return (
      <div>
        <div className="site-page-dropdown-menu">
          {buttons}
        </div>
        <div className="site-page-dropdown-modal" onClick={()=>this.setState({openSiteMenu: false})} />
      </div>
    )
  }

  renderUserMenu() {
    if(!this.state.openUserMenu)
      return null;

    let buttons = [];
    let menu = AppConfig.menu.user;
    for(let i = 0; i < menu.length; i++) {
      let icon = React.createElement(getIcon(menu[i].icon));
      let notify = menu[i].notify && this.state[menu[i].notify];

      if(menu[i].role != undefined && menu[i].role != Server.user.getRole())
        continue;

      buttons.push(
        <NavLink key={i} to={menu[i].path} onClick={()=>this.setState({openUserMenu: false})}>
          <div className="site-page-row" style={{justifyContent: 'space-between', marginRight: '5px'}}>
            <div className="site-page-row">
              <div className="site-page-dropdown-menu-icon">{icon}</div>
              <div>{menu[i].name}</div>
            </div>
            {notify &&
              <div className="site-page-notify-circle">
                <BsExclamationCircleFill size="1.2em" />
              </div>
            }
          </div>
        </NavLink>
      )  
    }

    // logout
    buttons.push(
      <div key={menu.length} onClick={()=>this.onLogout()}>
        <div className="site-page-dropdown-menu-icon"><BsBoxArrowDown /></div>
        <div>Logout</div>
      </div>
    )  
  
    return (
      <div>
        <div className="site-page-dropdown-menu" style={{right: '0px', left: 'unset'}}>
          {buttons}
        </div>
        <div className="site-page-dropdown-modal" onClick={()=>this.setState({openUserMenu: false})} />
      </div>
    )
  }

  renderPortrait() {
    let profile = Server.user.getProfile();
    let portrait = getPortraitImage(profile);
    let notify = this.state.notifications || this.state.friends;

    return (
      <div style={{position: 'relative'}}>
        <img 
          className="site-page-portrait" 
          src={portrait} 
          onClick={()=>this.setState({openUserMenu: !this.state.openUserMenu})}
        />
        {notify &&
          <div className="site-page-notify-circle" style={{position: 'absolute', right: '-6px', top: '-3px'}}>
            <BsExclamationCircleFill size="1.4em" />
          </div>
        }
        {this.state.offline && !notify && AppConfig.community &&
          <div className="site-page-notify-circle" style={{backgroundColor: '#F0B232', width: '12px', height: '12px', position: 'absolute', right: '-2px', top: '2px'}}>
          </div>
        }
      </div>
    )
  }

  renderHeader() {
    let menu = AppConfig.menu.site;
    let links = [];
    for(let i = 0; i < menu.length; i++) {
      if(menu[i].guest != undefined && menu[i].guest == Server.account.isLoggedIn())
        continue;
      if(menu[i].role != undefined && menu[i].role != Server.user.getRole())
        continue;
      let notify = menu[i].notify && this.state[menu[i].notify];

      links.push(
      <NavLink key={i} to={menu[i].path}>
        <div className="site-page-row" style={{columnGap: '3px'}}>
          <div>{menu[i].name}</div>
          {notify && 
            <div className="site-page-notify-circle">
              <BsExclamationCircleFill size="1.1em" />
            </div>
          }

        </div>
      </NavLink>)
    }

    let notify = this.state.activity || this.state.notifications || this.state.chats;

    return (
      <div className="headerbar-contents">
        <div className="headerbar-left" style={{position: 'relative'}}>
          <div>
            <div id="hamburger" className="headerbar-hamburger" onClick={()=>this.setState({openSiteMenu: !this.state.openSiteMenu})}>
              <BsList />
            </div>
          </div>
          <NavLink to="/" onClick={(e:any)=>this.onLogoClick(e)}>
            <img className="headerbar-logo" src={AppConfig.logo}/>
          </NavLink>
          <div className="headerbar-menu">
            {links}
          </div>
        </div>
        {notify && 
          <div className="site-page-notify-circle headerbar-notify-circle">
            <BsExclamationCircleFill size="1.4em" />
          </div>
        }
        {Server.account.isLoggedIn() ?
          this.renderPortrait() :
          <button className="headerbar-login-button" onClick={()=>this.props.onLogin()}>Login</button>
        }
      </div>
    )
  }

  render() {
    return (
      <div className="headerbar">
        {this.renderHeader()}
        {this.renderSiteMenu()}
        {this.renderUserMenu()}
      </div>
    )
  }
}

export default HeaderBar;
